import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { IVendor } from './vendors.interface';
import { VendorsService } from './vendors.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { VendorsModalComponent } from './vendors-modal/vendors-modal.component';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.css']
})
export class VendorsComponent implements OnInit {
  vendors: IVendor[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    filters: {
      isDeleted: false
    },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  sortOptions: any = {
    "name": 'Nombre asc',
    "-name": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  curr!: string;

  constructor(
    public _VendorService: VendorsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private ref: ChangeDetectorRef
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewVendorModal());
    })
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.curr = this._AuthService.currency();
    this.getVendors(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getVendors(true);
      }
    }, 1000);
  }

  getVendors(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.vendors = [];
      this.clearSelection();
    }
    this._VendorService.getVendors(this.filter).subscribe((vendors: any) => {
      this.vendors = _.concat(this.vendors, vendors);
      const filter: any = this.filter;
      this.thereAreMore = vendors.length >= filter.limit;
      this.loading = false;
      this.ref.detectChanges();
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getVendors();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  sortVendors(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getVendors(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getVendors(true);
  }

  openNewVendorModal() {
    this.openVendorModal({});
  }

  openVendorModal(vendor: IVendor, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(VendorsModalComponent, config);
    self.dialogRef.componentInstance.vendor = vendor;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getVendors(true);
    });
  }

  openDeleteVendorConfirm(vendor: IVendor, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Vendoro",
      message: "Esta seguro que desea eliminar '" + vendor.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._VendorService.deleteVendor(vendor, hardDelete).subscribe(() => {
            if (hardDelete) this.getVendors(true);
            else vendor.isDeleted = true;
          })
        }
      });
  }

  openRestoreVendorConfirm(vendor: IVendor) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Vendoro",
      message: "Esta seguro que desea restaurar '" + vendor.name + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._VendorService.restoreVendor(vendor).subscribe(() => {
            vendor.isDeleted = false;
          })
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.vendors.every(vendor => {
        const id = vendor?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.vendors.forEach(vendor => {
        const id = vendor?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}